// extracted by mini-css-extract-plugin
var _1 = "IFrameComponent-module__animatedBackground--_1Q0a";
var _2 = "IFrameComponent-module__container--mqT3V";
var _3 = "IFrameComponent-module__footer--uB5yM";
var _4 = "IFrameComponent-module__link--rA6TG";
var _5 = "IFrameComponent-module__logo--Bylyf";
var _6 = "IFrameComponent-module__upgrade--YfgdO";
var _7 = "IFrameComponent-module__upgradeDescription--r5dcs";
var _8 = "IFrameComponent-module__upgradeTitle--rZSuH";
var _9 = "IFrameComponent-module__upsell--uuVUo";
export { _1 as "animatedBackground", _2 as "container", _3 as "footer", _4 as "link", _5 as "logo", _6 as "upgrade", _7 as "upgradeDescription", _8 as "upgradeTitle", _9 as "upsell" }
